import { render, staticRenderFns } from "./UpdateAvatar.vue?vue&type=template&id=5a5e2aa1"
import script from "./UpdateAvatar.vue?vue&type=script&lang=js"
export * from "./UpdateAvatar.vue?vue&type=script&lang=js"
import style0 from "./UpdateAvatar.vue?vue&type=style&index=0&id=5a5e2aa1&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports